function getShippingOptionCourier (option) {
  if (!option) return ''

  const valueCourier = String(option.value || '').split('==')[0]
  return String(option.key || valueCourier).toLowerCase()
}

function hasRequiredShippingOptionData (option) {
  if (!option || !option.value) return false
  if (getShippingOptionCourier(option) !== 'pos') return true

  const valueParts = String(option.value).split('==')
  const service = String(option.label || '').split('-')[1]
  const price = Number(valueParts[1])

  return valueParts[0].toLowerCase() === 'pos' && Boolean(service && service.trim()) && Number.isFinite(price) && price > 0
}

function isShippingOptionUnsupported (option, payment, coverageCheckEnabled) {
  if (!hasRequiredShippingOptionData(option)) return true

  const mustEnforceCoverage = coverageCheckEnabled || getShippingOptionCourier(option) === 'pos'
  if (!mustEnforceCoverage) return false

  return Boolean(option.unsupported || (payment === 'COD' && option.unsupported_cod))
}

function getCheapestValidShippingOption (options, payment, coverageCheckEnabled) {
  const validOptions = (Array.isArray(options) ? options : []).filter(option => (
    hasRequiredShippingOptionData(option) &&
    !isShippingOptionUnsupported(option, payment, coverageCheckEnabled)
  ))

  return validOptions.reduce((cheapest, option) => {
    if (!cheapest) return option

    const cheapestPrice = Number(String(cheapest.value).split('==')[1])
    const optionPrice = Number(String(option.value).split('==')[1])
    return optionPrice < cheapestPrice ? option : cheapest
  }, null)
}

module.exports = {
  hasRequiredShippingOptionData,
  isShippingOptionUnsupported,
  getCheapestValidShippingOption
}
